const CARRIER_LOGOS: Record<string, string> = {
  anPost:
    "https://a.storyblok.com/f/343430/102x23/623edbdd50/anpost.svg?cv=1768219390479",
  australiaPost:
    "https://a.storyblok.com/f/343430/60x13/6f23764c69/australiapost.svg?cv=1768219390352",
  bring:
    "https://a.storyblok.com/f/343430/144x54/5dd129a2a3/bring.svg?cv=1768219390533",
  canadaPost:
    "https://a.storyblok.com/f/343430/50x49/578b299ff9/canadapost.svg?cv=1768219390479",
  correos:
    "https://a.storyblok.com/f/343430/831x226/75693f81b7/correos.svg?cv=1768219390671",
  colissimo:
    "https://a.storyblok.com/f/343430/60x15/c8d33e4d8e/colissimo.svg?cv=1768219390364",
  laPoste: `https://a.storyblok.com/f/343430/60x20/e899ad15ad/laposte.svg?cv=1768219390679`,
  dpd: "https://a.storyblok.com/f/343430/227x95/c75e3f1087/dpd.svg?cv=1768219390829",
  deutschePost:
    "https://a.storyblok.com/f/343430/2500x625/646935cf18/deutschepost.svg?cv=1768219390567",
  postiGroup:
    "https://a.storyblok.com/f/343430/60x28/851b579b1c/postigroup.svg?cv=1768219390688",
  gls: "https://a.storyblok.com/f/343430/60x21/bff187c787/gls.svg?cv=1768219390570",
  postNL:
    "https://a.storyblok.com/f/343430/98x100/39dfb5f148/postnl.svg?cv=1768219390667",
  postnord: "https://a.storyblok.com/f/343430/60x11/0562e54a82/postnord.svg",
  evri: "https://a.storyblok.com/f/343430/40x30/938a808ac1/evri.svg?cv=1768219390803",
  royalMail:
    "https://a.storyblok.com/f/343430/202x388/ff04205ef6/royalmail.svg?cv=1768219390645",
  usPostalService:
    "https://a.storyblok.com/f/343430/2500x2500/66cfb02cb5/uspostalservice.svg?cv=1768219390818",
  brt: "https://a.storyblok.com/f/343430/60x29/eff48dde2f/brt.svg?cv=1768219390365",
  inPost: "https://a.storyblok.com/f/343430/120x72/6677bfca30/inpost.svg",
  fedEx:
    "https://a.storyblok.com/f/343430/70x80/4897cafa36/fedex.svg?cv=1768219390530",
  dhl: "https://a.storyblok.com/f/343430/65x50/bcb47a3a55/dhl.svg?cv=1768219390416",
  ups: "https://a.storyblok.com/f/343430/60x30/a7d9f4c809/ups.svg",
};

export function getCarrierLogo(
  country: string,
  methodId: string,
  methodName: string,
  isAllInOMG: boolean,
): string | undefined {
  const carrier = getCarrier(country, methodId, methodName, isAllInOMG);
  return carrier ? CARRIER_LOGOS[carrier] : undefined;
}

function getCarrier(
  country: string,
  methodId: string,
  methodName: string,
  isAllInOMG: boolean,
): string | null {
  switch (true) {
    case country === "IE" && methodId === "ASENDIA":
      return "anPost";
    case country === "AU" && methodId === "ASENDIA":
      return "australiaPost";
    case country === "NO" && methodId === "ASENDIA":
      return "bring";
    case country === "CA" && methodId === "ASENDIA":
      return "canadaPost";
    case country === "ES" && methodId === "ASENDIA":
      return "correos";
    case country === "FR" && /colissimo/i.test(methodName):
      return "colissimo";
    case country === "FR" && methodId === "ASENDIA":
      return "laPoste";
    case country === "DE" &&
      (methodId === "ASENDIA_SELECT" || methodId === "ASENDIA"):
      return "dpd";
    case country === "FI" && methodId === "ASENDIA":
      return "postiGroup";
    case country === "NL" && /gls/i.test(methodName):
      return "gls";
    case country === "NL" && methodId === "ASENDIA":
      return "postNL";
    case country === "SE" && methodId === "STANDARD":
      return "postnord";
    case country === "DK" && methodId === "DK_STANDARD":
      return "postnord";
    case country === "GB" && /evri/i.test(methodName):
      return "evri";
    case country === "GB" && methodId === "ASENDIA":
      return "royalMail";
    case country === "US" && methodId === "ASENDIA":
      return "usPostalService";
    case country === "IT" && /bartolini/i.test(methodName):
      return "brt";
    case country === "AT" && /gls/i.test(methodName):
      return "gls";
    case country === "PL" && /inpost/i.test(methodName):
      return "inPost";
    case methodId === "EXPRESS":
      return "ups";
    default:
      return null;
  }
}
